import Nav from "../components/general/NavBar.jsx";
import Footer from "../components/general/footer.jsx";
import TypebotFrame from "../components/general/TypebotFrame.jsx";

const ExerciceMiParcoursBureautique = () => {
  return (
    <section>
      <Nav />
      <div style={{ width: "100%", minHeight: "600px" }}>
        <TypebotFrame slug="exercice-mi-parcours-bureautique-4djksui"/>
      </div>
      <Footer border="contact" />
    </section>
  );
};

export default ExerciceMiParcoursBureautique;